import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const ProfilePage = lazyWithRetry(
  () => import("@features/users/ui/pages/ProfilePage"),
  "ProfilePage",
);
const ChangePasswordPage = lazyWithRetry(
  () => import("@features/password-recovery/ui/pages/ChangePasswordPage"),
  "ChangePasswordPage",
);
const ValidateSignaturePage = lazyWithRetry(
  () => import("@features/digital-signature/ui/pages/ValidateSignaturePage"),
  "ValidateSignaturePage",
);

export const AUTH_SELF_SERVICE_ALLOWED_ROLES = [1, 2, 3, 4, 5, 6, 7, 8];

/**
 * Rutas de autenticación y perfil de usuario
 * Todos los roles pueden acceder a estas rutas
 */
const authRoutes = buildRoutes([
  {
    path: "/profile",
    element: ProfilePage,
    roles: AUTH_SELF_SERVICE_ALLOWED_ROLES,
  },
  {
    path: "/change-password",
    element: ChangePasswordPage,
    roles: AUTH_SELF_SERVICE_ALLOWED_ROLES,
  },
  {
    path: "/firma",
    element: ValidateSignaturePage,
    roles: AUTH_SELF_SERVICE_ALLOWED_ROLES,
  },
]);

export default authRoutes;
